import { render, staticRenderFns } from "./answerImageContainer.vue?vue&type=template&id=23756f61&scoped=true"
import script from "./answerImageContainer.vue?vue&type=script&lang=js"
export * from "./answerImageContainer.vue?vue&type=script&lang=js"
import style0 from "./answerImageContainer.vue?vue&type=style&index=0&id=23756f61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23756f61",
  null
  
)

export default component.exports